import React, { useEffect } from 'react';
import { useProofOfLifeUrl } from 'commons/hooks';
import {
  dataDogLogger,
  DataDogLoggerActionTypes,
} from 'commons/utils/dataDogLogger';
import { getHostname } from 'commons/utils/getHostname';
import ProofOfLifeAiprise from './ProofOfLifeAiprise';
import ProofOfLifeError from './ProofOfLifeError';
import ProofOfLifeInfoSkeleton from './ProofOfLifeInfoSkeleton';

const AIPRISE_HOSTNAME_SUFFIX = '.aiprise.com';

function isAipriseUrl(url?: string): boolean {
  const hostname = getHostname(url);
  return !!hostname && hostname.endsWith(AIPRISE_HOSTNAME_SUFFIX);
}

function ProofOfLife(): JSX.Element {
  const { proofOfLifeUrl, isLoading, isError } = useProofOfLifeUrl();
  const hasUnusableUrl =
    !isLoading && !isError && !isAipriseUrl(proofOfLifeUrl);

  useEffect(() => {
    if (!hasUnusableUrl) return;

    dataDogLogger.generate({
      actionMessage: 'proof_of_life_url_not_supported',
      actionOwner: 'ProofOfLife',
      actionType: DataDogLoggerActionTypes.Error,
      actionData: { proofOfLifeUrlHost: getHostname(proofOfLifeUrl) },
    });
  }, [hasUnusableUrl, proofOfLifeUrl]);

  if (isLoading) return <ProofOfLifeInfoSkeleton />;

  if (isError || hasUnusableUrl) return <ProofOfLifeError />;

  return <ProofOfLifeAiprise />;
}

export default ProofOfLife;
